var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { CURRENT_CLAIM_TYPE_LAYOUT_COLOR } from '@declaration/layout';
import TitleImageDescriptionLayout from '@declaration/components/TitleImageDescriptionLayout.vue';
import { quitClaimDeclarationCloseCallback } from '@declaration/helpers/layoutMetaCallback';
import UserContactForm from '@declaration/components/appointment/UserContactForm.vue';
const claim = namespace('claim');
const contract = namespace('contract');
const settings = namespace('settings');
let RentalMaxAllowedDIAlert = class RentalMaxAllowedDIAlert extends Vue {
    constructor() {
        super(...arguments);
        this.illustration = require('@declaration/assets/images/documents/refus-total.svg');
        this.isUpdatingClaim = false;
    }
    get selfCareSettings() {
        return this.setting('selfCareSettings');
    }
    async nextStep() {
        await this.updateAndSaveClaimStep(this.currentStep);
    }
    get description() {
        return this.$tc('claim.declaration.break_in_damages.rental.alert.description', undefined);
    }
};
__decorate([
    claim.Action('updateAndSaveClaim')
], RentalMaxAllowedDIAlert.prototype, "updateAndSaveClaim", void 0);
__decorate([
    claim.Getter('userContact')
], RentalMaxAllowedDIAlert.prototype, "userContact", void 0);
__decorate([
    claim.Action('updateUserContact')
], RentalMaxAllowedDIAlert.prototype, "updateUserContact", void 0);
__decorate([
    claim.Getter('currentStep')
], RentalMaxAllowedDIAlert.prototype, "currentStep", void 0);
__decorate([
    contract.State('selectedContract')
], RentalMaxAllowedDIAlert.prototype, "selectedContract", void 0);
__decorate([
    claim.Action('updateAndSaveClaimStep')
], RentalMaxAllowedDIAlert.prototype, "updateAndSaveClaimStep", void 0);
__decorate([
    settings.Getter('setting')
], RentalMaxAllowedDIAlert.prototype, "setting", void 0);
RentalMaxAllowedDIAlert = __decorate([
    Component({
        components: {
            TitleImageDescriptionLayout,
            UserContactForm,
        },
        meta: {
            title: 'page.title.confirmation',
            color: CURRENT_CLAIM_TYPE_LAYOUT_COLOR,
            close: quitClaimDeclarationCloseCallback,
        },
    })
], RentalMaxAllowedDIAlert);
export default RentalMaxAllowedDIAlert;
